import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Mail = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.944 20.189H14.056a2.559 2.559 0 00-2.556 2.557v5.144c0 .237.257.509.467.619l37.786 21.583a.63.63 0 00.318.083.634.634 0 00.324-.088L87.039 28.53c.206-.115.752-.419.957-.559.248-.169.504-.322.504-.625v-4.601a2.559 2.559 0 00-2.556-2.556zm2.237 15.457a.644.644 0 00-.645.004L66.799 47.851a.637.637 0 00-.145.985l20.74 22.357a.632.632 0 00.467.204.64.64 0 00.639-.639V36.201a.638.638 0 00-.319-.555zM60.823 51.948a.636.636 0 00-.791-.118l-8.312 4.891a3.243 3.243 0 01-3.208.021l-7.315-4.179a.64.64 0 00-.751.086L12.668 78.415a.64.64 0 00.114 1.02c.432.254.849.375 1.273.375h71.153a.635.635 0 00.585-.385.635.635 0 00-.118-.689L60.823 51.948zm-26.489-2.347a.639.639 0 00-.115-1.023L12.453 36.146a.638.638 0 00-.953.556v32.62a.637.637 0 001.073.468l21.761-20.189z"
  }));
});
Mail.displayName = 'Mail';
export var MailDimensions = {
  height: 100,
  width: 100
};